import React, { forwardRef } from 'react';
import { DraggableComponentProps } from '.';
import { ScrollArea } from '@mantine/core';
import { Draggable as DraggableDnD } from 'react-beautiful-dnd';
import DraggableItem from './DraggableItem';

const Draggable = forwardRef<HTMLDivElement, DraggableComponentProps>(
  (props, ref) => {
    const { data, provided, snapshot, onHide } = props;
    return (
      <ScrollArea mx={-16}>
        <div
          {...provided.droppableProps}
          className={`draggable-container ${
            snapshot.isDraggingOver ? 'dragging-over' : ''
          }`}
          ref={ref}
        >
          {data.map((item, index) => (
            <DraggableDnD
              key={item?.posisi || item?.sequence}
              draggableId={
                item?.posisi
                  ? item?.posisi.toString()
                  : item?.sequence.toString()
              }
              index={index}
            >
              {(provided, snapshot) => (
                <DraggableItem
                  ref={provided.innerRef}
                  item={item}
                  snapshot={snapshot}
                  provided={provided}
                  onHide={onHide}
                />
              )}
            </DraggableDnD>
          ))}
        </div>
      </ScrollArea>
    );
  }
);

export default Draggable;
